



































































import {Component, Prop, Vue} from "vue-property-decorator";
import "swiper/dist/css/swiper.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import GenericCard from "@/components/stateless/GenericCard.vue";

@Component({
  components: {
    GenericCard,
    swiper,
    swiperSlide
  },
  computed: {}
})
export default class SwiperCarousel extends Vue {
  // arrowId: any = null;
  loaded = false;
  swiperOption: any = {
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true
    // },
  };

  @Prop({default: null}) private cardType!: string;
  @Prop({default: false}) private homePageCard!: boolean; //Hack for layout refactor - remove after experience detail page ref
  @Prop({default: []}) private elements!: any[];
  @Prop({default: "250"}) private imageHeight!: string;
  @Prop({default: ""}) private arrowId!: string;
  @Prop({default: null}) private breakpoints!: Object;
  @Prop({default: 3}) private slidesPerView!: number;
  @Prop({default: 16}) private spaceBetween!: number;

  created() {
    // this.arrowId = Date.now().toString();
  }

  mounted() {
    this.swiperOption.navigation = {
      prevEl: `#${this.arrowId}1`,
      nextEl: `#${this.arrowId}2`
    };

    this.swiperOption.slidesPerView = this.slidesPerView ? this.slidesPerView : 3;
    this.swiperOption.spaceBetween = this.spaceBetween ? this.spaceBetween : 16;
    this.swiperOption.breakpoints = this.breakpoints
      ? this.breakpoints
      : {
        1280: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      };
    // console.warn((this.swiperOption as any).navigation);

    this.loaded = true;
  }
}
